/** Open synchronously from the click so slow API responses do not trigger popup blocking. */
export async function openMessageAttachment(loadUrl: () => Promise<{ temporaryUrl?: string }>) {
  const preview = window.open("about:blank", "_blank");
  if (!preview) throw new Error("Autorisez les fenêtres contextuelles pour ouvrir la pièce jointe.");
  preview.opener = null;
  try {
    const response = await loadUrl();
    if (!response.temporaryUrl) throw new Error("Le lien de la pièce jointe est indisponible.");
    const url = new URL(response.temporaryUrl);
    if (!["https:", "http:"].includes(url.protocol)) throw new Error("Le lien de la pièce jointe est invalide.");
    preview.location.replace(url.href);
  } catch (error) {
    preview.close();
    throw error;
  }
}
